import { render, staticRenderFns } from "./V-pullButton.vue?vue&type=template&id=48006cba&scoped=true&"
import script from "./V-pullButton.vue?vue&type=script&lang=js&"
export * from "./V-pullButton.vue?vue&type=script&lang=js&"
import style0 from "./V-pullButton.vue?vue&type=style&index=0&id=48006cba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48006cba",
  null
  
)

export default component.exports